'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortMessages = undefined;

var _immutable = require('immutable');

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _sortBy = require('transmute/sortBy');

var _sortBy2 = _interopRequireDefault(_sortBy);

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var _getMessageGroup = require('../../pubnub-message/operators/getMessageGroup');

var _PubNubMessageGroups = require('../../constants/PubNubMessageGroups');

var _PubNubMessageGroups2 = _interopRequireDefault(_PubNubMessageGroups);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HISTORY = _PubNubMessageGroups2.default.HISTORY,
    PUBLISHING = _PubNubMessageGroups2.default.PUBLISHING;

/**
 * Sort PubNubMessageRecords in a ThreadHistory
 *
 * @param {ThreadHistory} threadHistory
 * @returns {ThreadHistory}
 */

var sortMessages = exports.sortMessages = function sortMessages(threadHistory) {
  return threadHistory.updateIn(_keyPaths.MESSAGES, (0, _pipe2.default)((0, _sortBy2.default)(_commonMessageFormatGetters.getTimestamp), function (messages) {
    return messages.groupBy(_getMessageGroup.getMessageGroup);
  }, function (groupedMessages) {
    var history = groupedMessages.get(HISTORY, (0, _immutable.OrderedMap)());
    var publishing = groupedMessages.get(PUBLISHING, (0, _immutable.OrderedMap)());
    return history.concat(publishing);
  }));
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/operators/sortMessages.js
// module id = 231
// module chunks = 2 3